import React from 'react';
import { useCarousel } from './carousel';
import { cn } from '../../utils/cn';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const _carouselContentVariants = cva(
    'rocco-carousel-content h-full select-none overflow-hidden',
    {
        variants: {
            variant: {
                default: '',
                fullPage: 'px-6 md:px-12',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

interface CarouselContentProps
    extends
        React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof _carouselContentVariants> {}

export const CarouselContent = ({
    variant,
    className,
    ...props
}: CarouselContentProps) => {
    const { carouselRef } = useCarousel();

    return (
        <div
            ref={carouselRef}
            className={cn(
                _carouselContentVariants({ variant }),
                'backface-hidden will-change-transform',
            )}
        >
            <div className={cn('flex h-full', className)} {...props} />
        </div>
    );
};
